<template>
    <!-- 财务移动门户单点登录 -->
    <div></div>
</template>
<script>
    import apiLoginPage from '@/api/login-page/index'
    import {saveToken} from '@/utils/cache'

    export default {
        name: '',
        data() {
            return {
                loading: true,
            }
        },
        methods: {
            checkLogin(reqPath,ticket) {
                let param = {
                    key: reqPath,
                    ticket:ticket
                }
                apiLoginPage.commssoLogin(param, {timeout: 60000}).then(res => {
                    saveToken(res.data)
                    this.$store.dispatch('mars/user/getUserInfo')
                    console.log("redirect to home")
                    this.$router.push({path: 'home'})
                }).catch((err) => {
                    console.log('绑定用户出错了' + err)
                })
            },
        }
        ,
        mounted() {
            let this_url = location.href
            console.log("url:"+this_url)
            if(this_url.indexOf("#/commsso")>0){
                let commssoPath = process.env.VUE_APP_FIS_COMMSSO_LOGIN
                //console.log("redirect commsso url:"+this_url)
                //commsso回传时可能会回传类似这样的url：http://192.168.50.111:9610/?ctk=CAre6_ApQfWXwrgUwejw6w&tk=gDPOTGdKQ620epxbbpM78g#/commsso/，
                //得转一下转换
                let testurl = this_url.substring(this_url.length-10);
                if(this_url.indexOf("?ctk") > 0 && testurl==='#/commsso/'){
                    let arr = this_url.split("?")
                    arr[0] = arr[0] + '#/commsso?'
                    arr[1] = arr[1].replace('#/commsso', '')
                    let newUrl = arr.join('')
                    //console.log("newUrl:"+newUrl)
                    window.location.href = newUrl
                    return;
                }

                if(this_url.indexOf("?ctk") > 0){
                    let ticket = this.$route.query.ctk
                    //console.log("ticket:"+ticket)
                    if(ticket){
                        this.checkLogin(this_url,ticket)
                    }
                }else{
                    let encode_url = encodeURIComponent(this_url)
                    window.location.href = commssoPath + 'login?redirectUrl=' + encode_url
                }
            }
        }
        ,
    }
</script>
<style lang="scss" scoped></style>
